<template>
  <div class="tabs" :class="[`of-${slots.length}`, isActive ? 'active' : null]">
    <tabs-head
      :tabs="slots"
      :active="activeTab"
      @update:active="set"/>
    <div class="body">
      <div v-for="name in slots" :key="name">
        <slot v-if="activeTab === name" :name="name"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['initial', 'isCloseable'],
  data() {
    return {
      activeTab: null,
    }
  },
  computed: {
    isActive() {
      return this.slots.some(slot => this.activeTab === slot)
    },
    slots() {
      return Object.keys(this.$slots)
    },
  },
  methods: {
    set(slotName) {
      if (this.isCloseable && slotName === this.activeTab) {
        this.activeTab = null
      } else {
        this.activeTab = slotName
      }
    },
  },
  // watch: {
  //   active(activeTabName) {
  //     this.$emit('change', activeTabName)
  //   },
  // },
  created() {
    this.activeTab = typeof this.initial === 'undefined'
      ? this.slots[0]
      : this.initial
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.tabs {
  width: 100%;
  // .body {}

  &.fill {
    &.of-3 {
      .tab {
        text-align: center;
        width: 33.2%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Tabs.vue